import React, { useEffect, useState } from 'react';

import { DeleteOutlined as TrashOutlineIcon, FileOutlined as FileOutlineIcon } from '@ant-design/icons';
import { Button } from 'antd';

import productService from 'v2/services/product';

interface IProps {
  file: any;
  onRemove: any;
  index: any;
  itemIndex: any;
}

const File: React.FC<IProps> = ({ file, onRemove, index, itemIndex }) => {
  const [fileName, setFileName] = useState<any>(null);

  useEffect(() => {
    let cancelled = false;
    const fileId = typeof file === 'object' ? file?.upload_id : file;

    if (fileId && !file?.name) {
      (async () => {
        try {
          const response = await productService.loadFileById(fileId);
          if (!cancelled) setFileName(response?.data);
        } catch {
          if (!cancelled) setFileName({ name: `Arquivo #${fileId}`, extension: '' });
        }
      })();
    }

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const nameFile = (f: any) => {
    if (f && !f.name) return fileName?.name ? `${fileName.name}.${fileName.extension}` : 'Carregando...';
    return f.name;
  };

  return (
    <li className='flex items-center gap-3 border-b border-gray-200 px-4 py-2'>
      <FileOutlineIcon style={{ fontSize: 28 }} />
      <div className='flex-1'>
        <div className='font-medium'>Arquivo</div>
        <div className='text-sm text-gray-500'>{nameFile(file)}</div>
      </div>
      <Button type='text' icon={<TrashOutlineIcon />} onClick={() => onRemove(nameFile(file), itemIndex, index)} />
    </li>
  );
};

export default File;
